module.exports = __webpack_public_path__ + "img/product-m-val2.3cfb580b.png";